var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionDialog',{attrs:{"persistent":"","max-width":400,"value":_vm.value,"bubble-icon":{
    icon: _vm.icon,
    colour: 'yellow',
  },"header":_vm.header || _vm.$tc('modal.heading.areYouSure'),"primary-button":{
    label: _vm.$tc('button.confirm'),
    action: () => _vm.confirm(),
    colour: 'pink',
    loading: _vm.loading,
  },"secondary-action":{
    label: _vm.$t('button.cancel'),
    action: () => _vm.cancel(),
    colour: 'transparent',
  }},scopedSlots:_vm._u([{key:"body",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }